<script lang="ts">
  export let customClass: string = 'stroke-gray-950';
</script>

<svg
  class={customClass}
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <rect
    x="1"
    y="1"
    width="22"
    height="22"
    rx="11"
    fill="white"
    style="fill:white;fill-opacity:1;"
  />
  <rect
    x="1"
    y="1"
    width="22"
    height="22"
    rx="11"
    stroke="#C4CBD8"
    style="stroke:currentColor;stroke-opacity:1;"
    stroke-width="2"
  />
</svg>
